import { keyify } from '@Hooks/LibraryInitialization/MoreUnderscore';
import { createSelector } from 'reselect';

import { stateParamsSelectorFactory, sort } from '@Selectors/StateParamsSelectors';

import { similarityMolKey, sortingPropertiesReducerKey } from './SortingPropertiesConstants';

export function sortingPropertiesBranch(state) {
  return state.get(sortingPropertiesReducerKey);
}

export const baseParamsForSortingProperties = stateParamsSelectorFactory(['context', 'databaseId', 'resultName']);
// eslint-disable-next-line no-shadow
export function keyForSortingPropertiesSelectorFn(baseParamsForSortingProperties) {
  return keyify(baseParamsForSortingProperties);
}
export const keyForSortingProperties = createSelector([baseParamsForSortingProperties], keyForSortingPropertiesSelectorFn);
// eslint-disable-next-line no-shadow
export function sortingPropertiesSelectorFn(key, sortingPropertiesBranch) {
  return sortingPropertiesBranch.get(key);
}
export const sortingProperties = createSelector([keyForSortingProperties, sortingPropertiesBranch], sortingPropertiesSelectorFn);

// eslint-disable-next-line no-shadow
function similarityMolSelectorFn(sortingPropertiesBranch) {
  return sortingPropertiesBranch.get(similarityMolKey);
}
export const similarityMolSelector = createSelector([sortingPropertiesBranch], similarityMolSelectorFn);

// eslint-disable-next-line no-shadow
export function currentSortingPropertiesBySortValueSelectorFn(sortingProperties, sort) {
  if (!sortingProperties) {
    return null;
  }

  return sortingProperties.find((item) => {
    return item.get('value') === sort;
  });
}
export const currentSortingPropertiesBySortValue = createSelector([sortingProperties, sort], currentSortingPropertiesBySortValueSelectorFn);
